var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 93,
    viewBox: "0 0 88 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.483 35.2758V38.4826H37.9192L40.1283 44.8964H42.483V48.1033H41.2328L43.4738 54.6101L49.0603 35.8498L51.5865 31.7674V0H36.4141V6.41377H42.483V9.62066H36.4141V16.0344H42.483V19.2413H36.4141V25.6551H42.483V28.862H36.4141V34.1117L36.8146 35.2758H42.483Z",
    fill: "#AEA6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9281 64.4055C35.7549 65.5549 37.7453 66.3849 39.8226 66.8635L41.9755 59.6384L28.2202 19.7095L19.666 22.9997L33.9281 64.4055Z",
    fill: "#AEA6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1855 16.695L18.2383 4.77979L18.6312 19.9852L27.1855 16.695Z",
    fill: "#AEA6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9997 67.3448C46.8073 67.3429 49.5819 66.7054 52.1367 65.4752L63.0927 42.0104L64.7176 32.805C64.4142 32.8371 64.0986 32.8916 63.7861 32.8916C62.4309 32.8971 61.0911 32.5883 59.8611 31.9872C58.631 31.386 57.5408 30.507 56.6672 29.4121L51.8287 37.2353L42.877 67.287C43.2517 67.3095 43.6234 67.3448 43.9997 67.3448Z",
    fill: "#AEA6C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4181 29.208C65.3053 30.8579 70.0057 28.1192 71.9159 23.0908C73.8261 18.0624 70.4609 5.39844 70.4609 5.39844C70.4609 5.39844 59.7446 12.0912 57.8344 17.118C55.9242 22.1448 57.5295 27.558 61.4181 29.208Z",
    fill: "#AEA6C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3324 54.5173C88.2225 49.2139 88.2225 43.7863 87.3324 38.4829H65.4538C66.321 41.0563 66.7624 43.7684 66.7586 46.5001C66.7586 52.879 64.3608 58.9966 60.0928 63.5072C55.8247 68.0178 50.036 70.5518 44 70.5518C37.964 70.5518 32.1753 68.0178 27.9072 63.5072C23.6392 58.9966 21.2414 52.879 21.2414 46.5001C21.2376 43.7684 21.679 41.0563 22.5462 38.4829H0.667588C-0.222529 43.7863 -0.222529 49.2139 0.667588 54.5173H9.93793C10.8174 58.6936 12.3782 62.6762 14.5503 66.2866L7.99586 73.2135C10.9059 77.6357 14.5383 81.4745 18.7228 84.5498L25.2772 77.623C28.6936 79.9185 32.462 81.568 36.4138 82.4974V92.2945C41.4321 93.2352 46.5679 93.2352 51.5862 92.2945V82.4974C55.538 81.568 59.3064 79.9185 62.7228 77.623L69.2772 84.5498C73.4617 81.4745 77.0941 77.6357 80.0041 73.2135L73.4496 66.2866C75.6218 62.6762 77.1826 58.6936 78.0621 54.5173H87.3324Z",
    fill: "#AEA6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord5);
export default __webpack_public_path__ + "static/media/accord_5.b0bd6144fb14a37f8f64801f88db97b9.svg";
export { ForwardRef as ReactComponent };